import "./ModalBox.css";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

function ModalBox({
  isOpen,
  title,
  description,
  buttonText,
  buttonType,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">{title}</div>
        <div className="modal-body-desc">{description}</div>
        <div className="modal-footer">
          <PrimaryButton onClick={onClose} type={buttonType}>
            {buttonText}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default ModalBox;
